import { downloadFile } from '#utils/download';
import { Button, Message } from '@bedrock/components';
import { SignOut } from '@bedrock/icons-react';
import React from 'react';
import {
  demandCreateExportDemandPlanTask,
  demandExportCooperateData,
  myWorkspaceCreateExportAllDemandTask,
  myWorkspaceCreateExportAllTrumpetTask,
  myWorkspaceCreateExportTodoDemandTask,
  myWorkspaceCreateExportTodoTrumpetTask,
  myWorkspaceGetExportDemandTaskResult,
  outsourceDemandSourceCreateExportDemandSourceKolTask,
  outsourceWorkbenchesGetExportDemandTaskResult,
  workbenchesExportDemand
} from '#services/api';
import { ButtonSize } from '@bedrock/components/es/Button/Button';
import { ButtonProps } from '@bedrock/components/lib/Button';

const EXPORT_FILE_KEY_MAP = {
  // 我的工作台常规采购全部列表
  DEMANDS_EXPORT_DEMAND: {
    taskApi: myWorkspaceCreateExportAllDemandTask,
    taskResultApi: myWorkspaceGetExportDemandTaskResult,
  },
  // 我的工作台常规采购待办列表
  DEMANDS_EXPORT_TODO_DEMAND: {
    taskApi: myWorkspaceCreateExportTodoDemandTask,
    taskResultApi: myWorkspaceGetExportDemandTaskResult,
  },
  // 常规采购列表
  DEMANDS_PLANNER_EXPORT: {
    taskApi: workbenchesExportDemand,
    taskResultApi: myWorkspaceGetExportDemandTaskResult,
  },
  // 我的工作台小喇叭待办列表
  TRUMPET_EXPORT_TODO_DEMAND: {
    taskApi: myWorkspaceCreateExportTodoTrumpetTask,
    taskResultApi: myWorkspaceGetExportDemandTaskResult,
  },
  // 我的工作台小喇叭全部列表
  TRUMPET_EXPORT_DEMAND: {
    taskApi: myWorkspaceCreateExportAllTrumpetTask,
    taskResultApi: myWorkspaceGetExportDemandTaskResult,
  },
  // 策划单报价信息
  PLAN_ORDER_QUOTE_INFO: {
    taskApi: demandCreateExportDemandPlanTask,
    taskResultApi: myWorkspaceGetExportDemandTaskResult,
  },
  // 批量提报达人
  BATCH_REPORTING_EXPERT: {
    taskApi: outsourceDemandSourceCreateExportDemandSourceKolTask,
    taskResultApi: outsourceWorkbenchesGetExportDemandTaskResult,
  },
  // 需求单-合作内容-导出
  DEMANDS_EXPORT_COOPERATE_DATA: {
    taskApi: demandExportCooperateData,
    taskResultApi: myWorkspaceGetExportDemandTaskResult,
  }
};

interface IProps {
  exportKey: keyof typeof EXPORT_FILE_KEY_MAP;
  params: any;
  intervalTime?: number;
  buttonSize?: ButtonSize;
  buttonProps?: ButtonProps;
  buttonText?: string;
}

const exportFilePolling = async ({ taskApi, taskResultApi, intervalTime }) => {
  return new Promise(async (resolve, reject) => {
    try {
      const resTask = await taskApi()
      const getExportResult = async () => {
        const resResult = await taskResultApi({ task_id: resTask?.data })
          .catch(err => {
            reject()
            return Promise.reject(err)
          })

        if (resResult?.data.status === 1) {
          setTimeout(getExportResult, intervalTime)
        } else if (resResult?.data.status === 2) {
          Message.error('导出失败')
          reject()
        } else if (resResult?.data.status === 3) {
          resResult?.data?.download_url && downloadFile(resResult.data.download_url)
          resolve('')
        } else {
          reject()
        }
      }
      setTimeout(getExportResult, intervalTime)
    } catch (error) {
      reject()
    }
  })
}

const ExportFilePollingBtn: React.FC<IProps> = ({
  exportKey,
  params = {},
  intervalTime = 500,
  buttonSize = 'medium',
  buttonProps = {},
  buttonText,
}) => {
  const [loading, setLoading] = React.useState(false);
  const taskApi = EXPORT_FILE_KEY_MAP[exportKey]?.taskApi;
  const taskResultApi = EXPORT_FILE_KEY_MAP[exportKey]?.taskResultApi;

  const handleExport = async (e) => {
    e && e.stopPropagation();
    setLoading(true);
    exportFilePolling({
      taskApi: () => taskApi(params),
      taskResultApi,
      intervalTime,
    }).finally(() => {
      setLoading(false)
    })
  }

  return (
    <Button size={buttonSize} icon={<SignOut />} type='checked-neutral' onClick={handleExport} loading={loading} {...buttonProps}>
      {buttonText || '导出'}
    </Button>
  )
}

export default ExportFilePollingBtn;
